export const DOCUMENTS_LIST = [
  'Dokumen Perencanaan Pendampingan Satuan Pendidikan',
  'Dokumen Pelaporan Pendampingan Satuan Pendidikan',
]
